import React, { useState } from "react";
import { auth, db } from "../../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

const AddAgentForm = ({ onAgentAdded }) => {
  const [newAgent, setNewAgent] = useState({
    email: "",
    password: "",
    name: "",
    contact: "",
    credits: 0,
    area: "",
    mandal: "",
    district: "",
    state: "",
    printStyle: "",
  });

  const [message, setMessage] = useState("");

  const generateAccountId = () =>
    Math.floor(100000 + Math.random() * 900000).toString();

  // const addAgent = async () => {
  //   try {
  //     const userCredential = await createUserWithEmailAndPassword(
  //       auth,
  //       newAgent.email,
  //       newAgent.password
  //     );
  //     const user = userCredential.user;
  //     const accountId = generateAccountId();

  //     await setDoc(doc(db, "users", user.uid), {
  //       uid: user.uid,
  //       accountId,
  //       username: newAgent.name,
  //       email: newAgent.email,
  //       contact: newAgent.contact,
  //       role: "agent",
  //       credits: newAgent.credits,
  //       area: newAgent.area,
  //       mandal: newAgent.mandal,
  //       district: newAgent.district,
  //       state: newAgent.state,
  //       isActive: true,
  //       printStyle: newAgent.printStyle,
  //       downloads: [],
  //     });

  //     setMessage("Agent created successfully.");
  //     setNewAgent({
  //       email: "",
  //       password: "",
  //       name: "",
  //       contact: "",
  //       credits: 0,
  //       area: "",
  //       mandal: "",
  //       district: "",
  //       state: "",
  //       printStyle: "",
  //     });
  //     onAgentAdded();
  //   } catch (error) {
  //     console.error("Error adding agent:", error);
  //     setMessage("Error: " + error.message);
  //   }
  // };

  const addAgent = async () => {
    if (
      newAgent.printStyle !== "selfPrinting" &&
      newAgent.printStyle !== "bulkOrder"
    ) {
      setMessage("Please select a valid Print Style.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        newAgent.email,
        newAgent.password
      );
      const user = userCredential.user;
      const accountId = generateAccountId();

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        accountId,
        username: newAgent.name,
        email: newAgent.email,
        contact: newAgent.contact,
        role: "agent",
        credits: newAgent.credits,
        area: newAgent.area,
        mandal: newAgent.mandal,
        district: newAgent.district,
        state: newAgent.state,
        isActive: true,
        printStyle: newAgent.printStyle,
        downloads: [],
      });

      setMessage("Agent created successfully.");
      setNewAgent({
        email: "",
        password: "",
        name: "",
        contact: "",
        credits: 0,
        area: "",
        mandal: "",
        district: "",
        state: "",
        printStyle: "",
      });
      onAgentAdded();
    } catch (error) {
      console.error("Error adding agent:", error);
      setMessage("Error: " + error.message);
    }
  };

  return (
    <div>
      <h3>Add Agent</h3>
      <div className="row g-3">
        {[
          "email",
          "password",
          "name",
          "contact",
          "credits",
          "area",
          "mandal",
          "district",
          "state",
          "printStyle",
        ].map((field, i) => (
          <div className="col-md-6" key={i}>
            {field === "printStyle" ? (
              <select
                className="form-control"
                value={newAgent.printStyle}
                onChange={(e) =>
                  setNewAgent({ ...newAgent, printStyle: e.target.value })
                }
              >
                <option value="">Select Print Style</option>
                <option value="selfPrinting">Self Printing</option>
                <option value="bulkOrder">Bulk Order</option>
              </select>
            ) : (
              <input
                className="form-control"
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                type={
                  field === "password"
                    ? "password"
                    : field === "credits"
                    ? "number"
                    : "text"
                }
                value={newAgent[field]}
                onChange={(e) =>
                  setNewAgent({ ...newAgent, [field]: e.target.value })
                }
              />
            )}
          </div>
        ))}
        <div className="col-12">
          <button className="btn btn-primary" onClick={addAgent}>
            Add Agent
          </button>
          {/* {message && <p className="text-success mt-2">{message}</p>} */}
          {message && (
            <p
              className={
                message.startsWith("Error") || message.includes("Please")
                  ? "text-danger mt-2"
                  : "text-success mt-2"
              }
            >
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddAgentForm;
